<template>
  <div>
    <breadcrumb-bar
      :crumbs="[{name:'Groups'},{name:'Messaging', link:'Messaging Home'},{name:'Message History'}]"></breadcrumb-bar>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <span class="caption-subject bold uppercase">Message History</span>
                </div>
              </div>
              <div class="portlet-body">
                <div class="vue-good-table" v-if="massMessages.length > 0 || Object.keys(serverParams.columnFilters).length !== 0 && serverParams.columnFilters.constructor === Object">
                  <vue-good-table
                    :columns="columns"
                    :rows="massMessages"
                    :pagination-options="{
                      enabled: true,
                        perPageDropdown: [10, 20, 50, 100, 200, 500],
                        dropdownAllowAll: true,
                        perPage: this.serverParams.perPage
                      }"
                    mode="remote"
                    :totalRows="totalRecords"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"

                  >
                    <template slot="table-column" slot-scope="props">
                      {{ props.column.label }}
                    </template>

                    <template slot="table-row" slot-scope="props">
                      <template v-if="props.column.field==='created_at'">{{ props.formattedRow[props.column.field] }}</template>
                      <template v-else-if="props.column.field==='after'">
                        <router-link :to="{ name: 'Message History Details', params: { id: props.row.id } }" class="btn green btn-sm">View</router-link>
                      </template>
                      <template v-else>{{props.formattedRow[props.column.field]}}</template>
                    </template>

                  </vue-good-table>
                </div>
                <div class="not-found-results" v-else>
                  <h4>No message history found.</h4>
                </div>
                <router-link tag="button" class="btn green pull-left" :to="{ name: 'Messaging Home' }">
                  Back
                </router-link>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
    import Breadcrumbs from '@/components/Breadcrumbs'
    import Spinner from '@/components/Spinner'
    import VueFormRender from '@/components/formbuilder/VueFormRender'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        data() {
            return {
                columns: [
                    {
                        label: 'Timestamp',
                        field: 'created_at',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Sent By',
                        field: 'send_by',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Message',
                        field: 'message',
                        filterOptions: {enabled: false}
                    },
                    {
                        label: 'Message Status',
                        field: 'status',
                        filterOptions: {enabled: false},
                        sortable: false
                    },
                    {
                        label: 'Actions',
                        field: 'after',
                        sortable: false
                    }
                ],
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                },
            }
        },
        components: {
            'breadcrumb-bar': Breadcrumbs,
            'vue-spinner': Spinner
        },
        created() {
            this.getMassMessages();
        },
        computed: {
            ...mapGetters({
                massMessages: 'getMassMessagesData',
                totalRecords: 'getResultsCount'
            }),
        },
        methods: {
            ...mapActions({
                getMassMessagesAction: 'GET_MASS_MESSAGES_ACTION'
            }),
            getMassMessages() {
                this.getMassMessagesAction({
                    columns_filter: this.serverParams.columnFilters,
                    limit: this.serverParams.perPage,
                    current_page: this.serverParams.page,
                    sort_by: this.serverParams.sort.field,
                    sort_order: this.serverParams.sort.type,
                });
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.getMassMessages();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage, page: 1});
                this.getMassMessages();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    },
                });
                this.getMassMessages();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.getMassMessages();
            }


        }
    }
</script>

<style scoped>
  .vue-good-table {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// History.vue?5f8d8458